import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, ArrowRight } from "lucide-react";
import { Logo } from "./Logo";
import { useQuote } from "./QuoteModal";
import { NAV_LINKS, LOCATIONS, PHONE_DISPLAY, TEL_URL, WA_URL } from "@/lib/site";

const SERVICE_LINKS = [
    "Lift Installation",
    "Maintenance & AMC",
    "Breakdown Service",
    "Repair",
];

export const Footer = () => {
    const openQuote = useQuote();

    return (
        <footer className="border-t border-blue-950 bg-[#070D18] text-white">
            <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
                <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
                    <div>
                        <Logo dark testid="footer-brand-logo" />
                        <p className="mt-5 text-sm leading-relaxed text-slate-400">
                            Premium Elevator Installation, Maintenance &amp; Breakdown Services
                            for residential and commercial properties.
                        </p>
                        <button
                            type="button"
                            onClick={openQuote}
                            data-testid="footer-quote-cta-btn"
                            className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#1D4ED8] px-5 py-2.5 text-sm font-bold text-white transition-colors duration-200 hover:bg-[#2563EB]"
                        >
                            GET A FREE QUOTE <ArrowRight className="h-4 w-4" />
                        </button>
                    </div>

                    <div>
                        <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-[#60A5FA]">
                            Quick Links
                        </h3>
                        <ul className="mt-5 space-y-3">
                            {NAV_LINKS.map((link) => (
                                <li key={link.to}>
                                    <Link
                                        to={link.to}
                                        className="text-sm text-slate-300 transition-colors duration-200 hover:text-white"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-[#60A5FA]">
                            Services
                        </h3>
                        <ul className="mt-5 space-y-3">
                            {SERVICE_LINKS.map((s) => (
                                <li key={s}>
                                    <Link
                                        to="/services"
                                        className="text-sm text-slate-300 transition-colors duration-200 hover:text-white"
                                    >
                                        {s}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-[#60A5FA]">
                            Contact
                        </h3>
                        <a
                            href={TEL_URL}
                            data-testid="footer-phone-link"
                            className="mt-5 flex items-center gap-3 text-sm font-semibold text-white transition-colors duration-200 hover:text-[#60A5FA]"
                        >
                            <Phone className="h-4 w-4 text-[#60A5FA]" /> {PHONE_DISPLAY}
                        </a>
                        <a
                            href={WA_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-whatsapp-link"
                            className="mt-3 flex items-center gap-3 text-sm font-semibold text-white transition-colors duration-200 hover:text-[#60A5FA]"
                        >
                            <MessageCircle className="h-4 w-4 text-[#60A5FA]" /> WhatsApp: {PHONE_DISPLAY}
                        </a>
                        <ul className="mt-5 space-y-3">
                            {LOCATIONS.map((loc) => (
                                <li key={loc.city} className="flex items-start gap-3 text-sm text-slate-400">
                                    <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#60A5FA]" />
                                    <span>
                                        <span className="font-semibold text-slate-200">{loc.city}</span>
                                        <br />
                                        {loc.short}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-14 border-t border-white/10 pt-7 text-center text-xs text-slate-500">
                    &copy; 2026 K1 ELEVATOR&rsquo;S. All Rights Reserved.
                </div>
            </div>
        </footer>
    );
};
